import React from 'react';
import {IPropsView} from '../Config/Factory.types';
import '../Style/FactoryBox.css';

const FactoryBox = (props: IPropsView) => (
    <div onClick={() => props.onClick && props.onClick()} className={`ai-factory-items ${props.className}`}>
        <img src={props.src} alt='factory icon' className='factory-icon-img' />
        <p>{props.title}</p>
    </div>
);

export default FactoryBox;
